var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMelody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 179,
    viewBox: "0 0 213 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.894 15.0662C206.273 21.1288 200.594 34.5543 198.408 47.3817C194.122 72.5402 192.422 124.094 155.383 125.272C147.239 125.529 139.725 117.977 140.111 109.916C140.497 101.858 148.696 95.0453 156.777 96.0671C164.859 97.0914 171.067 105.731 169.396 113.625L162.728 49.0707C145.568 61.6743 123.249 67.1748 102.119 64.0033C102.442 74.0093 105.764 83.6463 108.71 93.2224C111.657 102.801 114.285 112.763 113.167 122.714C112.049 132.665 106.424 142.695 97.0459 146.433C87.6677 150.171 74.9524 145.191 72.8856 135.392C70.821 125.591 83.7458 115.725 91.8421 121.721C99.815 127.625 96.7178 136.997 91.4509 143.53C81.2743 156.151 68.6729 161.725 51.7973 159.579C40.1782 158.101 29.1479 152.436 21.2329 143.883",
    stroke: "#F57D7D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.474 81.7418C125.771 82.6095 148.783 80.1231 164.998 68.0055",
    stroke: "#F57D7D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelody);
export default __webpack_public_path__ + "static/media/melody.a3deee850f36a410b2fb24d24a322751.svg";
export { ForwardRef as ReactComponent };